hrd.charts.BarChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions);
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.bar = {
			zerobased: dynamicOptions.zerobased
		};
		if(dynamicOptions.width != undefined){
			staticOptions.bar.width = dynamicOptions.width;
		} else if(dynamicOptions.ratio != undefined) {
			staticOptions.bar.width = {
				ratio: dynamicOptions.ratio
			};
		}
		if(dynamicOptions.space != undefined){
			staticOptions.bar.space = dynamicOptions.space;
		}
		this._adaptMulticolor(staticOptions, dynamicOptions);
	},
	_adaptMulticolor: function(staticOptions, dynamicOptions){
		if(dynamicOptions.useMulticolor){
			var colorList = (dynamicOptions.colors) ? dynamicOptions.colors : $.evaluate(dynamicOptions.colorScheme);
			staticOptions.data.color = function(color, d){
				var length = this.colorScheme.length;
				if (d.id) {
					return this.colorScheme[d.index % length];
				}
				return color;
			}.bind({colorScheme: colorList})
		}
	}
});